import { PerspectiveSidebar } from "./PerspectiveSidebar";
import { UserTopbar } from "./UserTopbar";

export function Shell({
  children,
}: {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}) {
  return (
    <div className="min-h-screen flex bg-background text-foreground">
      <PerspectiveSidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <UserTopbar />
        <main className="flex-1 px-4 sm:px-6 py-6">{children}</main>
      </div>
    </div>
  );
}
